import type { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';

/**
 * Chrome shared by every authenticated page.
 *
 * No fixed-position offset needed here, unlike the old AppBar: HamburgerNavBar
 * renders in normal document flow (matching AdminPortal's own Layout), so
 * content just follows it.
 */
const Layout = ({ children }: { children: ReactNode }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

export default Layout;
